import React, { Component } from 'react';
import { Text, View, TouchableOpacity, Dimensions } from '../src/web/react-native';
import { createMaterialTopTabNavigator } from '../src/navigation/topTabs';
import { connect } from 'react-redux';
import InProgress from './InProgress';
import TakeOver from './MyPosts/TakeOver';
import { GetTeamShiftLogsActionAsync } from './../Action/ShiftLogAction';
import { LoadingOverlay } from '../src/components';
import { Route } from '../src/app/Route';
import { DdLogs } from '../src/logging/datadog';

export class TeamLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      localPreference: {},
      isLoading: false,
      inProgressCount: this.props.shiftLogs.filter((val) => val.status != 'TakenOver').length,
      takeOverCount: this.props.shiftLogs.filter((val) => val.status == 'TakenOver').length,
      width: Dimensions.get('window').width,
    };
  }

  async componentDidMount() {
    DdLogs.info('teamlog did mount....');
    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
      });
    });
    this.focusTeamLogListener = this.props.navigation.addListener('focus', async () => {
      this.setState({});
    });
  }
  componentWillUnmount() {
    this.focusTeamLogListener();
  }
  render() {
    const width = this.state.width;
    const Tab = createMaterialTopTabNavigator();
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F4F8F9',
        }}>
        {<LoadingOverlay visible={this.state.isLoading} />}
        <View
          style={{
            flex: 1,
            width: 0.94 * width,
            marginTop: 5,
            backgroundColor: '#fff',
          }}>
          <Tab.Navigator
            initialRouteName={Route.inProgress}
            tabBar={(props) => (
              <TeamLogTabStatusBar props={props} shiftLogs={this.props.shiftLogs} />
            )}>
            <Tab.Screen
              name={Route.inProgress}
              component={InProgress}
              // props={this.props}
              initialParams={{ isTeamLog: this.props.route.params.isTeamLog }}
              options={{ title: 'In Progress' }}
            />
            <Tab.Screen
              name={Route.takenOver}
              component={TakeOver}
              // props={this.props}
              initialParams={{ isTeamLog: this.props.route.params.isTeamLog }}
              options={{ title: 'Taken Over' }}
            />
          </Tab.Navigator>
        </View>
      </View>
    );
  }
}
function TeamLogTabStatusBar({ props, params, shiftLogs }) {
  let { state, descriptors, navigation, position, route } = { ...props };
  const width = Dimensions.get('window').width;
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name;
        const isFocused = state.index === index;
        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
          });

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name, {
              isTeamLog: true,
            });
          }
        };
        // modify inputRange for custom behavior
        const inputRange = state.routes.map((_, i) => i);

        return (
          <TouchableOpacity
            accessibilityLabel={options.tabBarAccessibilityLabel}
            testID={options.tabBarTestID}
            onPress={onPress}
            style={{ flex: 1, marginVertical: 5 }}
            key={route.key}>
            <View
              style={[{ height: 45 }, getTextStyle(width, index, state.routes.length, isFocused)]}>
              <Text style={isFocused ? { color: '#fff' } : { color: '#000' }}>{label}</Text>
              <Text style={isFocused ? { color: '#fff' } : { color: '#000' }}>
                {
                  route.name == 'TakenOver'
                    ? shiftLogs.filter((val) => val.status == 'TakenOver').length
                    : shiftLogs.filter((val) => val.status != 'TakenOver').length
                  // takeOverCount : inProgressCount
                }
              </Text>
            </View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}
function getTextStyle(width, index, length, isFocused) {
  let selected = {};
  if (isFocused) {
    selected = { backgroundColor: '#00A3E0' };
  }

  if (index == 0) {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#EEF3F4',
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      marginLeft: 5,
      ...selected,
    };
  } else {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#EEF3F4',
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      marginRight: 5,
      ...selected,
    };
  }
}
const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.teamShiftLogs
});

const mapDispatchToProps = (dispatch) => {
  return {
    GetTeamShiftLogs: (preference) => {
      return dispatch(
        GetTeamShiftLogsActionAsync({
          siteCode: preference.siteCode,
          assetName:
            preference.post || preference.console || preference.businessTeam || preference.site,
        }),
      );
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamLogs);